module.exports = __webpack_public_path__ + "static/bg-online02-e33ff5403d877c17cb6b21553f485985.jpg";